import ReviewsCard from "components/HomeVideoReviews/ReviewsCard"

import type { ComponentProps } from "."

const Reviews = ({
  actions,
  avatar,
  display,
  flagLoading,
  isShowFlagButton,
  onSelect,
  onToggleFlagged,
  selected,
  serviceName,
  subheader,
  title
}: ComponentProps) => (
  <ReviewsCard
    actions={actions}
    avatar={avatar}
    display={display}
    flagLoading={flagLoading}
    isShowFlagButton={isShowFlagButton}
    onSelect={onSelect}
    onToggleFlagged={onToggleFlagged}
    selected={selected}
    serviceName={serviceName}
    subheader={subheader}
    title={title}
  />
)

Reviews.whyDidYouRender = true

export default Reviews
